import React, { useState } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import ReduxToastr from 'react-redux-toastr';
import { PersistGate } from 'redux-persist/integration/react';
import AuthenticationController from 'components/Authentication/AuthenticationController';
import ViewAsGate from 'components/Authentication/ViewAsGate';
import LoadingScreen from 'components/Utils/LoadingScreen';
import config from 'config';
import App from 'scenes/App';
import MiscUtils from 'services/MiscUtils';
import { store, persistor, purgeStorage } from 'careand-redux/store';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import socket from 'websockets/socket';
import configVersion from 'config/version.json';
import { disableReactDevTools } from 'services/disableReactDevTools';
import { Portal } from '@material-ui/core';
import { initializeActionExecutionWatcher } from 'services/ActionExecutionWatcher';
import ColorTokenInspector from 'components/Dev/ColorTokenInspector';
import DevKeyboardShortcuts from 'components/Dev/DevKeyboardShortcuts';
// DO NOT DELETE, EVEN IF UNUSED
import GlobalWindowOverrides from './services/GlobalWindowOverrides';
console.log(GlobalWindowOverrides && '');
//==============================

const PORTAL_VERSION = configVersion['client-version'];

const ErrorBoundary = MiscUtils.getBugsnagClient().getPlugin('react').createErrorBoundary(React);

const ENVIRONMENT = config.ENVIRONMENT;

if (ENVIRONMENT === 'production' && import.meta.env.PROD) disableReactDevTools();

// Initialize Proactive Carey execution watcher
initializeActionExecutionWatcher();

export const SOCKET = { instance: null };

/*const instance = createInstance({
  urlBase: "https://analytics.careand.ca",
  siteId: 1,
  trackerUrl: "https://analytics.careand.ca/rainbow",
  srcUrl: "https://analytics.careand.ca/unicorn",
  disabled: ENVIRONMENT !== 'production' || !PATIENT,
  linkTracking: true,
});*/

const theme = createTheme();

const AppWrapper = () => {
  const [authenticated, setAuthenticated] = useState();
  const [persistLoading, setPersistLoading] = useState(true);

  function onAuthenticationChange(authenticated) {
    setAuthenticated(authenticated);
  }

  const handlePersistLoad = () => {
    setPersistLoading(false);
  };

  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          {/*<ColorTokenInspector />*/}
          <DevKeyboardShortcuts />
          <PersistGate
            loading={<LoadingScreen />}
            persistor={persistor}
            onBeforeLift={handlePersistLoad}
          >
            <ViewAsGate>
              <BrowserRouter>
                <Portal>
                  <ReduxToastr
                    timeOut={4000}
                    newestOnTop={false}
                    preventDuplicates
                    maxAnimationDelay={275}
                    position="top-center"
                    transitionIn="fadeIn"
                    transitionOut="fadeOut"
                    progressBar={true}
                    closeOnToastrClick={true}
                  />
                </Portal>
                <AuthenticationController
                  closeSocket={socket.close}
                  openSocket={socket.open}
                  version={PORTAL_VERSION}
                  onAuthenticationChange={onAuthenticationChange}
                />
                {authenticated !== undefined && (
                  <App/>
                )}
              </BrowserRouter>
            </ViewAsGate>
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default AppWrapper;
